import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import WhyUseSection from './components/WhyUseSection';
import ReviewSection from './components/ReviewSection';
import SEOArticlesGrid from './components/SEOArticlesGrid';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

function buildWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Sugargoo Spreadsheet Hub',
    url: 'https://sugargoosheet.baby/',
    description: 'The ultimate Sugargoo Spreadsheet resource platform for smarter international shopping. Discover updated product databases, shipping guides, reviews, and expert tutorials.',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://sugargoosheet.baby/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export default function Home() {
  const webSiteSchema = buildWebSiteSchema();

  return (
    <main>
      <JsonLd data={webSiteSchema} />
      <Navbar />
      <Hero />
      <CategoryDropdown />
      <CategoryGrid />
      <WhatIsSection />
      <WhyUseSection />
      <ReviewSection />
      <SEOArticlesGrid />
      <Footer />
    </main>
  );
}